<template>
    <v-list-item ref="infoWindow" lines="three" class="pl-0">
        <template v-slot:prepend>
            <v-img
                tile
                class="thumb my-0"
                :src="$filters.imageUrl(offer.thumb, 250)"
                :alt="offer.name"
                lazy-src="/placeholder.png"
                :size="isCompactMode ? '50' : '125'"
                @error="onImgError"
                @load="load"
            >
                <template v-slot:placeholder>
                    <v-row v-show="!imgError && offer.thumb" class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="grey-lighten-5" />
                    </v-row>
                </template>
            </v-img>
        </template>
        <div class="align-self-start" :class="isCompactMode ? 'small-content' : ''">
            <v-rating class="d-flex mr-3" size="x-small" density="compact" readonly :model-value="offer.category" />
            <v-list-item-title :title="offer.name">
                <nuxt-link v-if="hotelPageLink" no-prefetch :to="hotelPageLink">
                    <span class="text-wrap">{{ offer.name }}</span>
                </nuxt-link>
                <span v-else class="text-wrap">
                    {{ offer.name }}
                </span>
            </v-list-item-title>
            <v-list-item-subtitle class="mb-2">
                <div v-if="offer.address" class="text-wrap">
                    <v-icon size="small">mdi-map-marker</v-icon>
                    {{ offer.address }}
                </div>
                <div v-if="offer.distance">
                    <strong>{{ $t('distance') }}:</strong>
                    {{ offer.distance }} km from center
                </div>
                <div v-if="offer.district || offer.district === 'other'">
                    <strong>{{ $t('district') }}:</strong>
                    {{ offer.district }}
                </div>
            </v-list-item-subtitle>
            <div class="text-right">
                <v-btn color="primary" size="x-small" @click="changeFilter">{{ $t('tours.show_tours') }}</v-btn>
            </div>
        </div>
    </v-list-item>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class TourMapInfoWindow extends Vue {
        @Prop() offer
        @Prop({default: true}) withLink

        imgError = false
        clientWidth = 201

        load() {
            this.setSize()
        }

        onImgError() {
            this.imgError = true
            return false
        }

        setSize() {
            this.clientWidth = this.$refs.infoWindow.$el.clientWidth
        }

        changeFilter() {
            toursStore.SET_FILTER({
                key: 'hotelName',
                value: [this.offer.name],
            })
            toursRuntimeStore.filter()
        }

        get hotelPageLink() {
            // if (this.withLink) {
            //     return hotelsRuntimeStore.hotelPageLink(this.offer, hotelsStore.searchRequest)
            // }
            return null
        }

        get isCompactMode() {
            return this.clientWidth < 200
        }
    }

    export default TourMapInfoWindow
</script>

<style scoped>
    .small-content {
        font-size: 0.8rem !important;
    }
</style>
